import script from "./Treview.vue?vue&type=script&setup=true&lang=js"
export * from "./Treview.vue?vue&type=script&setup=true&lang=js"

import "./Treview.vue?vue&type=style&index=0&id=0e3de859&lang=css"

export default script